/** アクセス情報（HomeAccess.vue・MAccess.vue 共通）の文言：日本語・中国語・英語 */
export default {
  ja: {
    mapTitle: 'のぞみクリニック築地 GoogleMap アドレス', corp: '医療法人社団 天裕会', name: 'のぞみクリニック築地',
    address: ['〒104-0045', '東京都中央区築地7-11-5 中銀ベル築地マンシオン2階', '東京メトロ日比谷線 築地駅1番、2番出口より徒歩4分'],
    hours: '診療時間', days: ['月', '火', '水', '木', '金', '土', '日'], off: '休',
    n1: '※ 受付は３０分前までとなります。', n2: '※ 休診日：水曜・日曜・祝日・年末年始。',
    n3: '※ 月曜は、一般内科診療に加え、白川太郎医師による「がん自由診療」（11:00〜16:00）を実施しております。', n4: '※ 中国語対応可能。',
    line: 'LINE予約', lineSub: 'メディダイエット', web: 'WEB予約', webSub: 'オンライン診療', contact: 'お問合せ',
  },
  zh: {
    mapTitle: 'のぞみクリニック築地 Google地图', corp: '医疗法人社团 天裕会', name: 'のぞみクリニック築地',
    address: ['〒104-0045', '東京都中央区築地7-11-5 中銀ベル築地マンシオン2階', '东京Metro日比谷线「築地站」1号・2号出口步行4分钟'],
    hours: '诊疗时间', days: ['一', '二', '三', '四', '五', '六', '日'], off: '休',
    n1: '※ 挂号截至诊疗结束前30分钟。', n2: '※ 休诊日：周三・周日・节假日・年末年初。',
    n3: '※ 周一除普通内科诊疗外，另有白川太郎医生的「癌症自费诊疗」（11:00〜16:00）。', n4: '※ 可用中文沟通。',
    line: 'LINE预约', lineSub: '医疗减重', web: '网上预约', webSub: '线上诊疗', contact: '联系我们',
  },
  en: {
    mapTitle: 'Google Map of Nozomi Clinic Tsukiji', corp: 'Tenyukai Medical Corporation', name: 'Nozomi Clinic Tsukiji',
    address: ['104-0045', 'Chugin Bell Tsukiji Mansion 2F, 7-11-5 Tsukiji, Chuo-ku, Tokyo', '4-minute walk from Exit 1 or 2 of Tsukiji Station (Tokyo Metro Hibiya Line)'],
    hours: 'Hours', days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], off: '–',
    n1: '* Reception closes 30 minutes before the end of each session.', n2: '* Closed: Wednesdays, Sundays, national holidays and the New Year holidays.',
    n3: '* On Mondays, Dr. Taro Shirakawa offers Cancer Care (Self-pay) (11:00–16:00) in addition to General Internal Medicine.', n4: '* Chinese-speaking staff available.',
    line: 'LINE booking', lineSub: 'Medical Diet', web: 'Online booking', webSub: 'Online consultation', contact: 'Contact',
  },
}
